import MultiLineHeader from '../components/DataTable/MultiLineHeader';
import HorseSireCell from '../components/DataTable/HorseSireCell';
import DamDamSireCell from '../components/DataTable/DamDamSireCell';
import ExpandCell from '../components/DataTable/ExpandCell';
import ResponsiveHeader from '../components/DataTable/ResponsiveHeader';

const DATA_TITLE = 'data-title';
const rootData = document.getElementById('root').dataset || {};

/**
 * Config for upcoming sales table
 */
export default {
    url: `/bloodstock/sales/catalogues/${rootData.venueid}/${rootData.salesdate}/data.json`,
    primaryColumn: 'lot_no',
    activeLot: rootData.lot,
    lotLetter: rootData.lotLetter,
    venueUid: rootData.venueid,
    initialPage: rootData.page,
    columns: [
        {
            columnName: '_spacer',
            displayName: '',
            headerDataAttrs: {
                [DATA_TITLE]: 'expand'
            },
            customCell: ExpandCell
        },
        {
            columnName: 'lot_no',
            headerDataAttrs: {
                [DATA_TITLE]: 'lot-no'
            },
            customHeader: {
                component: ResponsiveHeader,
                options: {
                    displayName: [
                        {
                            className: '',
                            displayName: 'Lot '
                        },
                        {
                            className: 'hidden-lg-down',
                            displayName: 'No'
                        }
                    ]
                }
            }
        },
        {
            columnName: 'horse_style_name',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: ['Horse name', 'Sire']
                }
            },
            customCell: {
                component: HorseSireCell,
                options: {
                    horseUid: 'horse_uid',
                    horseName: 'horse_style_name',
                    sireUid: 'sire_uid',
                    sireName: 'sire_style_name',
                    entered: 'entered'
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'horse-name'
            }
        },
        {
            columnName: 'horse_first_colour_code',
            headerDataAttrs: {
                [DATA_TITLE]: 'colour'
            },
            customHeader: {
                component: ResponsiveHeader,
                options: {
                    displayName: [
                        {
                            className: 'hidden-lg-down',
                            displayName: 'Colour'
                        },
                        {
                            className: 'hidden-sm-down hidden-xl-up',
                            displayName: 'Col'
                        }
                    ]
                }
            }
        },
        {
            columnName: 'horse_sex',
            displayName: 'Sex',
            headerDataAttrs: {
                [DATA_TITLE]: 'sex'
            }
        },
        {
            columnName: 'horse_age',
            displayName: 'Age',
            headerDataAttrs: {
                [DATA_TITLE]: 'age'
            }
        },
        {
            columnName: 'dam_style_name',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: ['Dam', 'Dam\'s sire']
                }
            },
            customCell: {
                component: DamDamSireCell,
                options: {
                    damUid: 'dam_uid',
                    damName: 'dam_style_name',
                    damSireUid: 'sire_of_dam_uid',
                    damSireName: 'sire_of_dam_style_name'
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'dam-sire'
            }
        },
        {
            columnName: 'seller_name',
            displayName: 'Vendor',
            headerDataAttrs: {
                [DATA_TITLE]: 'seller-name'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/js/config/upcomingSalesTable.js